// extracted by mini-css-extract-plugin
export default {"container":"notFound_container__bX0DD","code":"notFound_code__7RamT","text":"notFound_text__DCpZz","button":"notFound_button__zALVJ","logo":"notFound_logo__Tmg9b"};